import * as React from "react";
function SvgIcItalic(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.44 18H10l2.56-12H14l-2.56 12z" fill="currentColor" />
    </svg>
  );
}
export default SvgIcItalic;
